<template>
	<div id="chat-app" class="col-8">
		<h2>Send me a message!</h2>
		<br />
		<p><i>via telegram bot</i></p>
		<div class="row">
			<h3 class="col-3">Message:</h3>
			<div class="col-9 input-group">
				<textarea
					rows="5"
					class="form-control"
					v-model="message"
					v-on:keyup.enter.exact="send_message()"
					type="text"
					placeholder="..."
				></textarea>
				<button class="btn btn-secondary col-3" v-on:click="send_message()">
					Send
				</button>
			</div>
		</div>
		<p>{{ message_result }}</p>
	</div>
</template>

<script>
export default {
	name: 'Chat.vue',
	data: function() {
		return {
			message: '',
			message_result: ''
		};
	},
	methods: {
		send_message: function() {
			if (!this.$store.getters.isLoggedIn) {
				this.message_result = 'Login required!';
				return;
			}
			if (this.message === '') {
				this.message_result = 'Please write a message!';
				return;
			}
			this.message_result = 'Sending message...';
			this.$http
				.post(
					'/chat/telegram',
					{
						message: this.message
					},
					{ withCredentials: true }
				)
				.then(res => {
					this.message_result =
						'Successfully delivered message: ' + this.message;
					this.message = '';
				})
				.catch(error => {
					this.message_result =
						'Could not deliver message: ' + error.response.statusText;
					//alert(error.response.status + ' ' + error.response.data);
				});
		}
	}
};
</script>

<style scoped>
#chat-app {
	margin: 0 auto;
	margin-top: 25px;
	max-width: 650px;
}
</style>
